import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app";

var root = document.getElementById("root");

ReactDOM.render(<App />, root);







